/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateFacilityPhysician201ResponseData } from './CreateFacilityPhysician201ResponseData';
import {
    CreateFacilityPhysician201ResponseDataFromJSON,
    CreateFacilityPhysician201ResponseDataFromJSONTyped,
    CreateFacilityPhysician201ResponseDataToJSON,
    CreateFacilityPhysician201ResponseDataToJSONTyped,
} from './CreateFacilityPhysician201ResponseData';

/**
 * 
 * @export
 * @interface CreateFacilityPhysician201Response
 */
export interface CreateFacilityPhysician201Response {
    /**
     * 
     */
    data?: CreateFacilityPhysician201ResponseData;
}

/**
 * Check if a given object implements the CreateFacilityPhysician201Response interface.
 */
export function instanceOfCreateFacilityPhysician201Response(value: object): value is CreateFacilityPhysician201Response {
    return true;
}

export function CreateFacilityPhysician201ResponseFromJSON(json: any): CreateFacilityPhysician201Response {
    return CreateFacilityPhysician201ResponseFromJSONTyped(json, false);
}

export function CreateFacilityPhysician201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityPhysician201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CreateFacilityPhysician201ResponseDataFromJSON(json['data']),
    };
}

export function CreateFacilityPhysician201ResponseToJSON(json: any): CreateFacilityPhysician201Response {
    return CreateFacilityPhysician201ResponseToJSONTyped(json, false);
}

export function CreateFacilityPhysician201ResponseToJSONTyped(value?: CreateFacilityPhysician201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateFacilityPhysician201ResponseDataToJSON(value['data']),
    };
}

